/* eslint-disable consistent-return */
/* eslint-disable no-plusplus */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ApplicationState } from 'store';
import { submitQuoteWithPayment, setPaymentInfo } from 'store/modules/conlicitaseg_store/actions';
import { ConlicitasegState } from 'store/modules/conlicitaseg_store/types';
import SquareLoader from 'components/atoms/square_loader';
import PolicyError from 'components/atoms/policy_error';

const PaymentInfo: React.FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const shouldRedirect = useRef(false);

  const { selected_quote, request, formProcess } = useSelector<ApplicationState, ConlicitasegState>(
    (state) => state.session.conlicitaseg,
  );

  const [installments, setInstallments] = useState<string>('1');

  const fixedDueDate = (() => {
    const date = new Date();
    date.setDate(date.getDate() + 7);
    return date.toISOString().split('T')[0];
  })();

  const [dueDate, setDueDate] = useState<string>(fixedDueDate);

  const handleBack = () => {
    history.goBack();
  };

  const generateInstallmentOptions = () => {
    const maxInstallments =
      Number(selected_quote?.installments) === 0 ? 1 : Number(selected_quote?.installments);
    const options = [];
    for (let i = 1; i <= maxInstallments; i++) {
      options.push(
        <option key={i} value={i}>
          {i}x
        </option>,
      );
    }
    return options;
  };

  const handleContinue = () => {
    dispatch(
      setPaymentInfo({
        payment_type: 'boleto',
        installments,
        due_date: dueDate,
      }),
    );

    dispatch(
      submitQuoteWithPayment({
        selected_api_quote_id: selected_quote.selected_api_quote_id,
        contract_start_date: formProcess.contract_start_date,
        contract_end_date: formProcess.contract_end_date,
        payment_type: 'boleto',
        installments,
        contract_insured_amount: formProcess.contract_insured_amount,
        contract_days: formProcess.contract_days,
        due_date: dueDate,
        insurance_company_id: selected_quote.insurance_company_id,
        insurance_process_id: selected_quote.insurance_process_id,
      }),
    );
    shouldRedirect.current = true;
  };

  useEffect(() => {
    if (request?.submit_quote_with_payment?.loaded && shouldRedirect.current) {
      history.push('/conlicitaseg/informacoes');
      shouldRedirect.current = false;
    }
  }, [request?.submit_quote_with_payment?.loaded]);

  useEffect(() => {
    if (
      request?.submit_quote_with_payment?.error &&
      request?.submit_quote_with_payment?.errorField === 'due_date'
    ) {
      setDueDate(fixedDueDate);
    }
  }, [request?.submit_quote_with_payment?.error, request?.submit_quote_with_payment?.errorField]);

  const isDueDateError =
    request?.submit_quote_with_payment?.error &&
    request?.submit_quote_with_payment?.errorField === 'due_date';

  if (request?.submit_quote_with_payment?.error && !isDueDateError) {
    return <PolicyError />;
  }

  return (
    <div className="page-container">
      <div className="container-fluid big-resolutions py-5 px-md-5">
        <div className="row justify-content-center mt-5">
          <div className="col-12 mx-auto">
            <button type="button" className="btn btn-link px-0 mb-3" onClick={handleBack}>
              <i className="material-icons align-middle">keyboard_arrow_left</i>
              Voltar para etapa anterior
            </button>

            <div className="bg-white rounded shadow-sm p-4">
              <h2 className="mb-4">Selecione as opções do boleto</h2>
              <div className="row">
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="installments">Parcelas</label>
                    <select
                      className="form-control"
                      id="installments"
                      value={installments}
                      onChange={(e) => setInstallments(e.target.value)}
                    >
                      {generateInstallmentOptions()}
                    </select>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="dueDate">Data do vencimento</label>
                    <input
                      type="date"
                      className="form-control"
                      id="dueDate"
                      value={dueDate}
                      readOnly
                      disabled
                    />
                  </div>
                </div>
              </div>

              {isDueDateError && (
                <div className="alert alert-warning" role="alert">
                  Ocorreu uma atualização na data da cotação, tente novamente.
                </div>
              )}

              <div className="d-flex justify-content-end">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => handleContinue()}
                  disabled={
                    request?.submit_quote_with_payment?.loading || !installments || !dueDate
                  }
                >
                  {request?.submit_quote_with_payment?.loading ? (
                    <span style={{ display: 'flex', alignItems: 'center' }}>
                      Processando
                      <SquareLoader customClass="conlicitaseg-continue-quote" />
                    </span>
                  ) : (
                    'Continuar'
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentInfo;
